import ReactSelect from 'react-select'
import 'react-select/dist/react-select.css'

export default ReactSelect
export * from 'react-select'
